module.exports = __webpack_public_path__ + "static/img-main-75b8ecd79913defcbe436feca814bdd2.jpg";